import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import AllAssignedLeads from './AllAssignedLeads';
import './HRPanel.css';
import LeadAssignmentUpload from './LeadAssignmentUpload';
import UpcomingFollowUps from './UpcomingFollowUps';
import FollowUpTracker from './FollowUpTracker';
import Devices from './biometric/Devices';

function HRPanel() {
  const { user, hasPermission } = useAuth();
  const [activeTab, setActiveTab] = useState('');

  // Check permissions for each module
  const canAccessLeads = hasPermission('leads', 'read');
  const canAccessDevices = hasPermission('devices', 'read') || hasPermission('biometric-attendance', 'read');

  // Determine available tabs based on permissions
  const availableTabs = [];
  if (canAccessLeads) {
    availableTabs.push('assign', 'view', 'followups', 'upcoming');
  }
  if (canAccessDevices) {
    availableTabs.push('devices');
  }

  // Set default active tab to first available tab
  if (!activeTab && availableTabs.length > 0) {
    setActiveTab(availableTabs[0]);
  }

  // Check if user has any HR panel access
  if (availableTabs.length === 0) {
    return (
      <div className="hr-panel-container">
        <div className="restricted-message">
          <p>⚠️ You don't have permission to access this section</p>
        </div>
      </div>
    );
  }

  return (
    <div className="hr-panel-container">
      {/* Navigation Tabs */}
      <div className="hr-panel-tabs">
        {canAccessLeads && (
          <>
            <button
              className={`tab-button ${activeTab === 'assign' ? 'active' : ''}`}
              onClick={() => setActiveTab('assign')}
            >
              📤 Assign Leads
            </button>
            <button
              className={`tab-button ${activeTab === 'view' ? 'active' : ''}`}
              onClick={() => setActiveTab('view')}
            >
              📋 All Leads
            </button>
            <button
              className={`tab-button ${activeTab === 'followups' ? 'active' : ''}`}
              onClick={() => setActiveTab('followups')}
            >
              📅 Follow-up Tracker
            </button>
            <button
              className={`tab-button ${activeTab === 'upcoming' ? 'active' : ''}`}
              onClick={() => setActiveTab('upcoming')}
            >
              ⏰ Upcoming Follow-ups
            </button>
          </>
        )}
        {canAccessDevices && (
          <button
            className={`tab-button ${activeTab === 'devices' ? 'active' : ''}`}
            onClick={() => setActiveTab('devices')}
          >
            🔐 Devices
          </button>
        )}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {canAccessLeads && activeTab === 'assign' && (
          <div>
            <div className="hr-panel-header" style={{ marginBottom: '20px' }}>
              <h2>🎯 Assign Leads to Employees</h2>
            </div>
            <LeadAssignmentUpload />
          </div>
        )}

        {canAccessLeads && activeTab === 'view' && (
          <div>
            <AllAssignedLeads />
          </div>
        )}

        {canAccessLeads && activeTab === 'followups' && (
          <div>
            <FollowUpTracker />
          </div>
        )}

        {canAccessLeads && activeTab === 'upcoming' && (
          <div>
            <UpcomingFollowUps />
          </div>
        )}

        {canAccessDevices && activeTab === 'devices' && (
          <div>
            <Devices />
          </div>
        )}
      </div>
    </div>
  );
}

export default HRPanel;
